import {
  Auth,
  CredentialsSignInPayload,
  RequestResetPasswordPayload,
  ResetPasswordPayload,
} from "@/types/ApiResponses/Auth";
import { api } from "..";
import { ApiResponse } from "@/types/Api";

export const signInWithCredentials = async (
  payload: CredentialsSignInPayload
): Promise<Auth> => {
  const res = await api.client.post("/auth-new/credentials/sign-in", payload);
  return res.data;
};

export const requestResetPassword = async (
  payload: RequestResetPasswordPayload
): Promise<ApiResponse> => {
  const res = await api.client.post(
    "/auth-new/credentials/request-reset-password",
    payload
  );
  return res.data;
};

export const resetPassword = async (
  payload: ResetPasswordPayload
): Promise<ApiResponse> => {
  const res = await api.client.post(
    "/auth-new/credentials/reset-password",
    payload
  );
  return res.data;
};
